import React from "react"
import PropTypes from "prop-types"

import FormControlLabel from '@material-ui/core/FormControlLabel';

export default function createSelectionComponent(MuiComponent, { defaultCheckedValue, isChecked }) {
  class SelectionComponent extends React.Component {
    static propTypes = {
      onChange: PropTypes.func,
      onFieldChange: PropTypes.func.isRequired,
      onFieldFlush: PropTypes.func.isRequired,
      inPlace: PropTypes.bool,
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      checkedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    }

    static defaultProps = { checkedValue: defaultCheckedValue }

    _handleOnChange = e => {
      if (this.props.onChange) {
        this.props.onChange(e)

        if (e.isDefaultPrevented()) {
          return
        }
      }

      const event = {
        value: e.target.checked ? this.props.checkedValue : false,
        rawValue: e.target.checked,
      }

      this.props.onFieldChange(event)
      this.props.onFieldFlush(event)
    }

    render() {
      const {
        onFieldChange,
        onFieldFlush,
        value,
        checkedValue,
        label,
        inPlace,
        ...otherProps
      } = this.props
      const control = (
        <MuiComponent
          {...otherProps}
          checked={isChecked(value, this.props)}
          value={checkedValue.toString()}
          onChange={this._handleOnChange}
        />
      )

      if (label) {
        return <FormControlLabel control={control} label={label} />
      } else {
        return control
      }
    }
  }

  return SelectionComponent
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Field/createSelectionComponent.js